<template>
  <div class="Usermanagement">
    <div class="Usermanagementborder">
      <div class="header-box">运营设置</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item label="品牌名称：" prop="pName">
          <el-input v-model="ruleForm.pName" maxlength="20" placeholder="限制最多20位"></el-input>
        </el-form-item>
        <el-form-item label="厂商名称：" prop="cName">
          <el-input v-model="ruleForm.cName" maxlength="20" placeholder="和品牌名一致"></el-input>
        </el-form-item>
        <el-form-item label="库存设置：" prop="set">
          <el-input v-model.number="ruleForm.set" placeholder="数字"></el-input>
        </el-form-item>
        <el-form-item label="父体SKU编码前缀：" prop="SKU">
          <el-input v-model="ruleForm.SKU" maxlength="6" placeholder="限制最多六位"></el-input>
        </el-form-item>
        <el-form-item label="流水码起始数：" prop="pipeCode">
          <el-input v-model="ruleForm.pipeCode" maxlength="7" placeholder="数字"></el-input>
        </el-form-item>
        <div class="button">
          <el-button type="primary" style="float:right;" @click="submitForm('ruleForm')">保存设置</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
  name: "Usermana",
  data() {
    const pNameValid = (rule, value, callback) => {
      if (!/^[a-zA-Z]{1,20}$/.test(value)) {
        callback(new Error("只能输入大写字母且不超过20个"));
      } else {
        callback();
      }
    };
    const cNameValid = (rule, value, callback) => {
      if (this.ruleForm.pName !== value) {
        callback(new Error("品牌名称厂商名称输入不一致"));
      } else {
        callback();
      }
    };
    const checkPipe = (rule, value, callback) => {
      if (/\b(0+)/g.test(value)) {
        callback(new Error("请检查流水码起始数输入是否正确，不能以0开头"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pName: "",
        cName: "",
        set: "",
        SKU: "",
        type: "",
        pipeCode: "",
      },
      rules: {
        pName: [
          { validator: pNameValid, required: true, trigger: "blur" }
        ],
        cName: [
          { validator: cNameValid, required: true, trigger: "blur" }
        ],
        set: [
          { type: "number", required: true, message: "请输入库存并且只能是数值", trigger: "blur" }
        ],
        SKU: [
          { required: true, message: "请输入父体SKU", trigger: "blur" }
        ],
        pipeCode: [
          { validator: checkPipe, trigger: "blur" },
        ],
      },
      str: {},
    };
  },
  mounted() {
    this.getShow();
  },
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
  },
  methods: {
    getShow() {
      ajaxPost(Baseurl + "commonSettingController/getCommonSettingByStaffId", {
        // "0172f72c-8ee5-4991-b665-4c5fb2c42577"
        staffId: this.str.rid,
      }).then(res => {
        this.messageobj = res.data.data;
        this.$emit("makeobj", this.messageobj);

        const { field01, field02, stock, field03, pipeCode } = res.data.data;
        this.ruleForm.pName = field01;
        this.ruleForm.cName = field02;
        this.ruleForm.set = stock;
        this.ruleForm.SKU = field03;
        this.ruleForm.pipeCode = pipeCode.replace(/\b(0+)/gi, "");
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          ajaxPost(Baseurl + "commonSettingController/setCommonSetting", {
            staffId: this.str.rid,
            companyId: this.str.companyId,
            field01: this.ruleForm.pName,
            field02: this.ruleForm.cName,
            field03: this.ruleForm.SKU,
            stock: this.ruleForm.set,
            pipeCode: this.ruleForm.pipeCode.replace(/\b(0+)/gi, ""),
          }).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "设置成功!",
              });
              this.getShow();
            } else {
              this.$message({
                type: "error",
                message: res.data.data,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.Usermanagement {
  width: 70%;

  .Usermanagementborder {
    border-radius: 5px;
    width: 46%;
    border: 1px #eee solid;
    overflow: hidden;
    padding: 60px 20px 20px;
    position: relative;
    .header-box {
      width: 100%;
      padding-left: 8px;
      background: #eee;
      font-size: 16px;
      line-height: 40px;
      color: #828080;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
